import React from "react";
import { Button } from "@/components/ui/button";

const FooterContact = () => {
  const handleNavigate = (category: string) => {
    window.location.href = `/contact?category=${encodeURIComponent(category)}`;
  };

  return (
    <div>
      <h3 className="font-bold mb-4 text-lg">Contact</h3>
      <div className="space-y-3">
        <span
          role="button"
          tabIndex={0}
          className="cursor-pointer p-0 text-left text-md !text-white !hover:text-white/80 !hover:underline transition-colors h-auto justify-start block outline-none"
          onClick={() => handleNavigate("Technical Support")}
          onKeyPress={(e) => {
            if (e.key === "Enter" || e.key === " ") handleNavigate("Technical Support");
          }}
        >
          General Support
        </span>
        <span
          role="button"
          tabIndex={0}
          className="cursor-pointer p-0 text-left text-md !text-white hover:text-white/80 !hover:underline transition-colors h-auto justify-start block outline-none"
          onClick={() => handleNavigate("Media Inquiries")}
          onKeyPress={(e) => {
            if (e.key === "Enter" || e.key === " ") handleNavigate("Media Inquiries");
          }}
        >
          Media & Press
        </span>
        <span
          role="button"
          tabIndex={0}
          className="cursor-pointer p-0 text-left text-md !text-white hover:text-white/80 !hover:underline transition-colors h-auto justify-start block outline-none"
          onClick={() => handleNavigate("Partnership")}
          onKeyPress={(e) => {
            if (e.key === "Enter" || e.key === " ")
              handleNavigate("Partnership");
          }}
        >
          Partnerships
        </span>
      </div>
    </div>
  );
};

export default FooterContact;
